import { useCallback, useRef } from "react";

export function useIdempotencyKey() {
  const keyRef = useRef<string>(crypto.randomUUID());

  const regenerate = useCallback(function regenerateKey() {
    keyRef.current = crypto.randomUUID();
  }, []);

  return { key: keyRef.current, regenerate };
}
